{"browse_shop":"Pregledaj trgovinu","go_to_shop":"Idi u trgovinu","no_orders_found":"Nisu pronađene narudžbe","title":"Narudžbe"}